var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBilling(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.66743 13.6666H29.3322C29.3231 10.5523 29.2247 8.90129 28.1616 7.8382C26.99 6.66663 25.1044 6.66663 21.3332 6.66663H10.6665C6.89527 6.66663 5.00965 6.66663 3.83808 7.8382C2.77498 8.90129 2.67655 10.5523 2.66743 13.6666ZM29.3332 15.6666H2.6665V18.6666C2.6665 22.4379 2.6665 24.3235 3.83808 25.4951C5.00965 26.6666 6.89527 26.6666 10.6665 26.6666H21.3332C25.1044 26.6666 26.99 26.6666 28.1616 25.4951C29.3332 24.3235 29.3332 22.4379 29.3332 18.6666V15.6666ZM9.33317 20.3333C8.78089 20.3333 8.33317 20.781 8.33317 21.3333C8.33317 21.8856 8.78089 22.3333 9.33317 22.3333H9.3465C9.89879 22.3333 10.3465 21.8856 10.3465 21.3333C10.3465 20.781 9.89879 20.3333 9.3465 20.3333H9.33317Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBilling);
export default __webpack_public_path__ + "static/media/billing.f78a3c5a206b7ed03b0c1d3d51f30e59.svg";
export { ForwardRef as ReactComponent };